// 每日簽到打卡成功後會導購跳轉到商品頁；成功訊息在簽到 modal（具備 i18next）端翻譯好後寫入
// sessionStorage，這裡負責在跳轉後的「目標頁」載入時讀取，於右下角顯示 toast（3 秒後淡出移除），
// 比照 CampaignDashboard 的綠色成功提示。樣式見 _daily_checkin_modal.scss 的 .daily-checkin-toast。
const STORAGE_KEY = 'daily_checkin_toast'
const VISIBLE_MS = 3000
const FADE_MS = 300

const CHECK_ICON =
  '<svg class="daily-checkin-toast__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" ' +
  'fill="currentColor" aria-hidden="true">' +
  '<path fill-rule="evenodd" d="M16.704 5.29a1 1 0 0 1 .006 1.415l-7.59 7.59a1 1 0 0 1-1.42 0l-3.41-3.41a1 1 0 1 1 1.414-1.414l2.703 2.702 6.883-6.882a1 1 0 0 1 1.414 0Z" clip-rule="evenodd"/>' +
  '</svg>'

export const initDailyCheckinToast = () => {
  let message = null
  try {
    message = window.sessionStorage.getItem(STORAGE_KEY)
    if (message) window.sessionStorage.removeItem(STORAGE_KEY)
  } catch (err) {
    // sessionStorage 不可用（如無痕模式）時略過
    return
  }
  if (!message) return

  const toast = document.createElement('div')
  toast.className = 'daily-checkin-toast'
  toast.setAttribute('role', 'status')
  toast.innerHTML = CHECK_ICON

  // 訊息為簽到端已翻譯好的字串，使用 textContent 避免 XSS
  const text = document.createElement('span')
  text.textContent = message
  toast.appendChild(text)

  document.body.appendChild(toast)
  requestAnimationFrame(() => toast.classList.add('is-visible'))

  window.setTimeout(() => {
    toast.classList.remove('is-visible')
    window.setTimeout(() => toast.remove(), FADE_MS)
  }, VISIBLE_MS)
}

export default initDailyCheckinToast
